import React, { useEffect, useState } from "react";
import './AppointmentPage.css'
import { ChevronRight, ChevronDown, Phone ,MapPin,Menu,Search} from "lucide-react";
import BookingForm from "../Dashboard/BookingForm";
import ClinicBooking from "../Dashboard/ClinicBooking";
import PreferredTime from "../Dashboard/PreferredTime";
import { useNavigate } from "react-router-dom";
import { universalDummyData, mockAppointmentData, mockHealthScreenData, mockData,getAllHealthScreenData, location } from "./data";

import AppointmentSelection from '../Dashboard/AppointmentSelection'
import Step4 from "./StepComponents/Step4";
import axios from "axios";
import BookingJourney from "./index.js";
import UnifiedAppointmentType from "./UnifiedAppointmentType.js";

const AppointmentPage = (props) => {
  // console.log("AppointmentPage props:", props); // Debugging line
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);// we commeted 1step so it will start from two
  //3rd step type specification
  const [clinicBookingType, setClinicBookingType] = useState("");
  const [showAppointmentSelection, setShowAppointmentSelection] = useState(false);
  const [gpDuration, setGpDuration] = useState(false)
  const [gpLang, setGpLang] = useState(false)
  const [allClinics, setAllClinics] = useState({})

  const [combineAllClinicAndClinicById , setCombineAllClinicAndClinicById] = useState([])

  const [showAppoinmentData, setShowAppoinmentData] = useState({})
  const [getAppointmentDownPart, setGetAppointmentData] = useState({})
    const [dataExists, setDataExists] = useState(false);

  const [callbackData,setCallbackData] = useState();
  // appointmentSelection page 
  const [showAppoinmentDataDisplay, setshowAppoinmentDataDisplay] = useState(undefined)

  // for Booking form we need the duration api and language api call 

    // Fetch and transform the API response
    const fetchGpDuration = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URLOPEN}appointment-duration`,
          {
            headers: {
              "Content-Type": "application/json"
            },
            params: {
              category: "clinician_type"
            }
          }
        );

        // need format like this 
            // Transform the array to an object with duration_id as key
            
        const formattedData = response.data.data.reduce((acc, item) => {
          acc[item.duration_id] = item;
          return acc;
        }, {});

        const durationObjectById = response.data.data.reduce((acc, item) => {
          acc[item.duration_id] = {
            duration: item.duration,
            // content: item.content
          };
          return acc;
        }, {});

        // setGpDuration(response.data);
        // setDurationBYid(durationObjectById)
        setGpDuration(formattedData);
        // console.log("Formatted Duration gp data:", formattedData);
      } catch (error) {
        console.error("Error fetching health screen data:", error);
      }
    };
    const fetchGpLanguage = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URLOPEN}languages`,
          {
            headers: {
              "Content-Type": "application/json"
            },
            params: {
              category: "clinician_type"
            }
          }
        );

        // need format like this 
            // Transform the array to desired format
        const formattedData = response.data.data.map(lang => ({
          label: lang.language_name,
          value: lang.language_id
        }));

        // setGpLang(response.data);
        setGpLang(formattedData);
        // console.log("Formatted health screen data:", formattedData);
      } catch (error) {
        console.error("Error fetching health screen data:", error);
      }
    };
    const fetchAllClinic = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URLOPEN}clinics`,
          {
            headers: {
              "Content-Type": "application/json"
            },
            params: {
              category: "clinician_type"
            }
          }
        );

        // need format like this 
            // Transform the array to desired format
        // const formattedData = response.data.data.map(lang => ({
        //   label: lang.language_name,
        //   value: lang.language_id
        // }));

        const formattedData = response.data.data.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {});

        setAllClinics(response.data);
        setCombineAllClinicAndClinicById(formattedData)
        // setGpLang(formattedData);
        // console.log("Formatted health screen data:", formattedData);
      } catch (error) {
        console.error("Error fetching all clinic data:", error);
      }
    };


    useEffect(() => {

  
      fetchGpDuration();
      fetchGpLanguage()
      fetchAllClinic()
    }, []);

    // console.log("___ClinicAPIData___",{ allClinics, combineAllClinicAndClinicById, gpDuration, gpLang  })

    useEffect(() => {
      //ready data for clinicBooking
      const formatDataForAppointment = {
        showAppoinmentData : {
          clinic: {
            productCategory: {
              title: "Gp appointmnet",
              product_category_id: 1,
            },
          },
        //   gender: "male",
        //   language: {
        //     label: "English",
        //     value: 1,
        //   },
        //   duration: 1,
        },
        data : {
          clinic : {
            "id": null,
            "name": "",
            "latitude": "",
            "longitude": "",
            "address": "",
            "clinic_website_description": "",
            "position": ""
        },
        // clinic : allClinics[0], // add first clinic 
        // durationObjectById : {
        //   1: {duration: '15'},
        //   2: {duration: '30'}
        // },
          allClinicData : allClinics, 
          allClinicDataByID : combineAllClinicAndClinicById,
          isProtected : false
        },
      }
      setShowAppoinmentData(formatDataForAppointment)
    }, [allClinics,combineAllClinicAndClinicById ])
    

  const handleContinue = () => {
    setCurrentStep((prev) => prev + 1);
  };

  //! step 1 dummy data start [getAllHealthScreenData]

  const callbackAppointment = (data, formType) => {
    // console.log("Callback triggered with:", data, formType);
    setCallbackData(data);
    handleContinue();
  };

  const callBackForbackpage = () => {
    // console.log("Back button clicked");
  };

  //! step 1 dummy data end

  //! step 2 dummy data start [mockAppointmentData, mockHealthScreenData, mockData ]

const mockCallbackBookingForm = (formData, type) => {
  // console.log("Booking form submitted:", { formData, type });

  if (!formData) {
    return;
  }

    // Handle language - works whether formData.language is the value or the full object
    let selectedLanguage;
    if (typeof formData.language === 'object') {
      // If language comes as {label, value} object
      selectedLanguage = {
        label: formData.language.label,
        value: formData.language.value
      };
    } else {
      // If language comes as just the value (number)
      const langObj = gpLang.find(lang => lang.value === formData.language);
      selectedLanguage = {
        label: langObj?.label || 'English', // fallback to English
        value: formData.language
      };
    }

  // Format the appointment data with the form selections
  const formattedAppointmentData = {
    showAppoinmentData: {
      clinic: {
        productCategory: {
          title: "GP appointment",
          product_category_id: 1,
        },
      },
      gender: formData.gender, // Add gender from form
      language: selectedLanguage?.value,
      selectedLanguage,
      duration: formData.duration, // Add duration from form
      type: type // Add booking type
    },
    data: {
      clinic: {
        "id": null,
        "name": "C",
        "latitude": "",
        "longitude": "",
        "address": "",
        "clinic_website_description": "",
        "position": ""
      },
      durationObjectById: gpDuration, // Use the gpDuration data
      allClinicData: allClinics,
      allClinicDataByID: combineAllClinicAndClinicById,
      isProtected: false
    }
  };

  setShowAppoinmentData(formattedAppointmentData)
  setClinicBookingType(type);
  setCurrentStep(3);
};

  // console.log("getAppointmentDownPart", getAppointmentDownPart)

  const mockCallBackForBackPage = (source) => {
    // console.log("Back to:", source);
    setCurrentStep(1);
    // navigate('/book');
    
  };

  //! step 2 dummy data end

  //! step 3 dummy data start [universalDummyData]

  // Modified callback for ClinicBooking
  const callbackClinicBooking = (data, type) => {
     setDataExists(false)
    // console.log("ok_callbackClinicBooking data:", data, type);

    if (!data) return;

    let selectedLanguage;
    if (typeof showAppoinmentData.showAppoinmentData.language) {
      const langId = showAppoinmentData.showAppoinmentData.language
      // If language comes as just the value (number)
      const langObj = gpLang.find(lang => lang.value === langId);
      selectedLanguage = {
        label: langObj?.label || 'English', // fallback to English
        value: langObj?.value || showAppoinmentData.showAppoinmentData.language
      };
    }

    const appointmentPayload = {
      showAppoinmentData: {
        clinic : showAppoinmentData.showAppoinmentData.clinic,
        duration : showAppoinmentData.showAppoinmentData.duration,
        gender:showAppoinmentData.showAppoinmentData.gender,
        language:selectedLanguage,
        type: type,
        selectedClinics: data.selectedClinics,
        selectedSlots: data.selectedSlots
      },
      data: {
        isProtected:false,
        allClinicDataByID: combineAllClinicAndClinicById,
        date: new Date().toISOString().split('T')[0] // Current date
      }


    };
    if(data.selectedSlots.length > 0 ){
      setGetAppointmentData(appointmentPayload)


      setShowAppointmentSelection(true);      
    }

  };

  const callBackForbackpageClinicBooking = (page) => {
    setCurrentStep(currentStep - 1 )
  };


  // Mock callback functions
  const callbackPreferredTime = (data, type) => {
    // console.log("Preferred time callback:", data, type);
    if( data?.selectedSlots.length > 0 ){ // enable only when we select slots 
      setShowAppointmentSelection(true);// Enable AppointmentSelectionHardcoded
    }
    
  };

  const callBackForbackpagePreferredTime = (page) => {
  };

    //! New callback for AppointmentSelection


  //! step 3 dummy data end


  //! step 4 appointment Data 
  const callbackAppointmentSelection = (selectedSlot, type) => {
    setShowAppointmentSelection(false);
    setCurrentStep(currentStep + 1 )
  };

  const handleBack = () => {
    // console.log(text)
    setCurrentStep(currentStep-1)
  };
  
  const handleContinueStep4 = () => {
  };

  let today = new Date();
  let year = today.getFullYear();


  const bookingDetails = {
    showAppoinmentData: {
      ...showAppoinmentData,
      ...showAppoinmentData.showAppoinmentData,
      price: callbackData?.info.price || "0.00" // Add price from callbackData
    },
    callbackData,
    date: callbackData?.date +year || "20 June, 2025",
    time: callbackData?.info.start_time,
    isProtected : false,
    data: {
      clinic: {
        "id": 40,
        "name": "City Medical Center",
        "latitude": "51.5074",
        "longitude": "0.1278",
        "address": "123 Medical St, London",
        "clinic_website_description": "<p>Modern medical facility</p>",
        "position": "Main Building"
      },
      durationObjectById: gpDuration, // Use the gpDuration data
      allClinicData: allClinics,
      allClinicDataByID: combineAllClinicAndClinicById,
      isProtected: false
    }

    // "11:45",
  };
 
  return (
    <div className="page-wrapper">
      <div className="top-bar" style={{display:"none"}}>
        <div className="top-bar-inner">
          <div className="top-links">
            <span>For Patients</span>
            <span>For Business Customers</span>
            <span>Become a Member</span>
          </div>
        </div>
      </div>
      

      <main className="main">

        {process.env.REACT_APP_SHOW_HEADER === "true" && (

          <>
                  {currentStep==0?
        <>
        <div className="app-container">
      {/* Top Bar */}
                <div className="top-bar">
                  <div className="top-bar-inner">
                    <div className="top-links">
                      <span>For Patients</span>
                      <span>For Business Customers</span>
                      <span>Become a Member</span>
                    </div>
                  </div>
                </div> 
                 <header className="main-header"       >
                  <div className="header-inner">
                  <div className="header-rowBooking">
                    {/* Logo */}
                    <div className="logo">
                      <img src={"https://pbldcbe.webdezign.uk/static/media/ldc_logo_new.1f2a7d791d5f16307994.png"} alt="Logo" style={{ height: "40px" }} />
                    </div>
        
                    {/* Contact */}
                    <div className="contact-info">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "end",
                        }}
                      >
                        <ChevronRight size={12} />
                        <span>Book online</span>
                      </div>
                      <div className="contact-call">
                        <ChevronRight size={12} />
                        <span>Or call 020 3993 0813</span>
                      </div>
                    </div>
        
                    {/* Mobile Menu Icon */}
                    <Menu className="mobile-menu-icon" />
                  </div>
                </div>
        
                {/* Navigation */}
                <nav className="navigation">
                  <div className="nav-inner">
                    <div className="nav-links">
                      <Search className="icon-small" />
                      <span className="nav-item">
                        Services <ChevronDown className="icon-small" />
                      </span>
                      <span className="nav-item">
                        Blood Tests <ChevronDown className="icon-small" />
                      </span>
                      <span className="nav-item">
                        STI Tests <ChevronDown className="icon-small" />
                      </span>
                      <span className="nav-item">Health screens</span>
                      <span className="nav-item">Prices</span>
                      <span className="nav-item">
                        Locations <ChevronDown className="icon-small" />
                      </span>
                      <span className="nav-item">Online Doctor</span>
                      <span className="nav-item">About</span>
                    </div>
                  </div>
                </nav>
        
                {/* Search Section */}
                <div className="search-section">
                  <div className="search-inner ">
                    <span className="search-title">Book at your nearest clinic</span>
                    <div className="search-form">
                      <input type="text" placeholder="Enter a location" />
                    </div>
        
                    <button style={{ display: "flex", alignItems: "center" }}>
                      <span className="location-icon">
                        <MapPin style={{ color: "#008385" }} size={12} />
                      </span>{" "}
                      Use your current location
                    </button>
                  </div>
                </div>
              </header>
              </div>
              </>: <header className="main-header"       >
                  <div className="header-inner">
                  <div className="header-rowBooking">
                    {/* Logo */}
                    <div className="logo">
                      <img src={"https://pbldcbe.webdezign.uk/static/media/ldc_logo_new.1f2a7d791d5f16307994.png"} alt="Logo" style={{ height: "40px" }} />
                    </div>
        
                    {/* Contact */}
                    <div className="contact-info">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "end",
                        }}
                      >
                        <ChevronRight size={12} />
                        <span>Book online</span>
                      </div>
                      <div className="contact-call">
                        <ChevronRight size={12} />
                        <span>Or call 020 3993 0813</span>
                      </div>
                    </div>
        
                    {/* Mobile Menu Icon */}
                    <Menu className="mobile-menu-icon" />
                  </div>
                </div>
              </header>
             
                
                }
          
          </>
        )}

              

        {currentStep === 0 && (
          <BookingJourney onNext={()=>(  setCurrentStep(1))}/>
        )}
        {currentStep === 1 && (
          <UnifiedAppointmentType onNext={()=>(  setCurrentStep(2))} onBack={() => setCurrentStep(0)} productCategoryId={props.productCategoryId} productId={props.productId}/>
        )}
        {currentStep === 2 && (
          <BookingForm
            showAppoinmentData={mockAppointmentData}
            getAllHealthScreenData={mockHealthScreenData}
            // data={mockData}
            data={{durationObjectById : gpDuration , languageData: gpLang }}
            callbackBookingForm={mockCallbackBookingForm}
            callBackForbackpage={mockCallBackForBackPage}
          />
        )}
        {currentStep === 3 && (
          <>
            {/* // PreferredTimeclinic or  PreferredTime */}
            {clinicBookingType === "PreferredTimeclinic" && (
              // For ClinicBooking
              <>

              <ClinicBooking
              check={dataExists}
              clinicId={props.clinicId}
                showAppoinmentData={showAppoinmentData.showAppoinmentData}
                data={showAppoinmentData.data}
                metaData={getAppointmentDownPart?.showAppoinmentData}
                callback={callbackClinicBooking}
                callBackForbackpage={callBackForbackpageClinicBooking}
                getAllHealthScreenData={
                  universalDummyData.getAllHealthScreenData
                }
              />


              </>
            )}


            {clinicBookingType === "PreferredTime" && (
              // For PreferredTime
              <>
              {/* <h1>PreferredTime</h1> */}
              <PreferredTime
               check={dataExists}
               clinicId={props.clinicId}
               goback={()=>setCurrentStep(currentStep-1)}
                showAppoinmentData={showAppoinmentData.showAppoinmentData}
                metaData={getAppointmentDownPart?.showAppoinmentData}
                data={showAppoinmentData.data}
                callback={callbackClinicBooking}
                callBackForbackpage={callBackForbackpagePreferredTime}
                getAllHealthScreenData={
                  universalDummyData.getAllHealthScreenData
                }
              />
              </>
            )}



            {showAppointmentSelection && (
                <AppointmentSelection  
                  showAppoinmentData={getAppointmentDownPart.showAppoinmentData}
                  data={getAppointmentDownPart.data}
                  callback={callbackAppointment} 
                  callBackForbackpage={() => {setShowAppointmentSelection(false);setDataExists(true)}} 
                />
              )}

            
          </>
        )}

        {currentStep === 4 && ( 
                <Step4
                onBack={handleBack}
                // onBack={ok}
                onContinue={handleContinueStep4}
                bookingDetails={bookingDetails}
              />
        ) }
      </main>
      
      {process.env.REACT_APP_SHOW_HEADER === "true"  && (
        <>
        
      <footer className="footer">
        <div className="logo" style={{display:"flex",justifyContent:"center"}}>
          <img src={"https://pbldcbe.webdezign.uk/static/media/ldc_logo_new.1f2a7d791d5f16307994.png"} alt="Logo" style={{ height: "40px" }} />
        </div>
      </footer>        
        </>
      )}


<style jsx>
        {`
          .app-container {
            // font-family:  'Lato', sans-serif;
            background-color: white;
          }

          .top-bar {
            background-color: #4b5563;
            color: white;
            padding: 0.5rem 1rem;
            padding-left: 0px;
            font-size: 0.9rem;
          }

          .top-bar-inner {
            margin-left: 10px;
            display: flex;
            justify-content: start;
          }

          .top-links span {
            margin-right: 1.5rem;
            cursor: pointer;
          }

          .main-header {
            background-color: #008385;
            color: white;
          }

          .header-inner {
            margin: auto;
            padding: 1rem;
          }

          .header-rowBooking {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .logo {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .logo-title {
            font-size: 1.25rem;
            font-weight: bold;
          }

          .logo-subtitle {
            font-size: 0.85rem;
            opacity: 0.9;
          }

          .contact-info {
            text-align: right;
            display: none;
          }

          .contact-call {
            display: flex;
            justify-content: end;
            align-items: center;
            gap: 0.3rem;
          }

          .mobile-menu-icon {
            display: block;
          }

          @media (min-width: 768px) {
            .contact-info {
              display: block;
            }
            .mobile-menu-icon {
              display: none;
            }
          }

          .navigation {
            border-top: 0.05px solid #d3eced;
            background-color: #008385;
            padding: 0.5rem 1rem;
          }
                      @media (max-width: 768px) {
          .navigation {
            display:none;
          }
          }

          .nav-links {
            display: flex;
            gap: 1rem;
            overflow-x: auto;
            white-space: nowrap;
            font-size: 0.9rem;
            align-items: center;
          }

          .nav-item {
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 0.25rem;
          }

          .search-section {
            background: #f2fafa;
            color: #333;
            padding: 0.4rem;
          }

          .search-inner {
            margin: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 1rem;
          }

          @media (min-width: 768px) {
            .search-inner {
              flex-direction: row;
              justify-content: center;
              align-items: center;
            }
          }

          .search-form {
            display: flex;
            gap: 0.5rem;
          }

          .search-form input {
            padding: 0.5rem;
            border: 1px solid #ccc;
            border-radius: 5px;
          }

          .search-form button {
            padding: 0.5rem;
            border: 1px solid #ccc;
            background: #f0f0f0;
            color: #0d9488;
            border-radius: 5px;
            cursor: pointer;
          }

          button {
            border: 0;
            outline: 0;
            background: transparent;
          }

          .purple-banner {
            background-color: #5d0e93;
            color: white;
            text-align: center;
            padding: 0.4rem;
            font-weight: bold;
          }

          .hero-section {
            background-color: #008385;
            z-index: -1;
          }

          .hero-inner {
            position: relative;
            margin: auto;
            background-image: url("https://pbldcbe.webdezign.uk/static/media/doctor-patient.31b3df054c73cf0734d1.jpg"); /* Replace with your actual image path doctor image */
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            height: 52vh; 
          }

          .hero-text {
            position: absolute;
            top: 100px;
            left: 100px;
            max-width: fit-content;
            padding: 1rem;
            background-color: rgba(255, 255, 255, 0.7);
            backdrop-filter: blur(4px);
            text-align: left;
          }

          .hero-text h2 {
            margin: 0;
            padding-right: 2rem;
            font-size: 2.5rem;
            font-weight: 50;
          }

          .hero-text button {
            background: #14b8a6;
            color: white;
            padding: 1rem 2rem;
            border: none;
            border-radius: 9999px;
            font-size: 1rem;
            cursor: pointer;
          }

          .selectButton {
            background: #008385;
            color: white;
            padding: 1rem 2rem;
            border: none;
            border-radius: 9999px;
            font-size: 1rem;
            cursor: pointer;
          }

          .hero-image {
            flex: 1;
          }

          .hero-image img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .main-features-section {
            position: relative;
            z-index: 2;
            margin-top: -3rem;
            background: #fff;
            margin-inline: 0.8rem;
          }

          .features-section {
            background: #f9fafb;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2rem;
            padding: 4rem 1rem;
          }

          @media (min-width: 768px) {
            .features-section {
              flex-direction: row;
              justify-content: center;
            }
          }

          .feature {
            background: white;
            padding: 2rem;
            border-radius: 8px;
            text-align: center;
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
          }

          .feature h3 {
            color: #0d9488;
            margin-top: 1rem;
          }

          .featured-section {
            color: #008385;
            text-align: center;
            padding: 2rem 1rem;
          }
        `}
      </style>
    </div>
  );
};

export default AppointmentPage;
